import { MdOutlinePriceChange } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { BiSupport } from "react-icons/bi";
const cards = [
  {
    id: 1,
    header: "Reliable Prices",
    desc: "Accurate, fixed-price quote and detailed cost breakdown at the outset – no spiralling costs and no surprises!",
    img: <MdOutlinePriceChange />,
  },
  {
    id: 2,
    header: "Experienced Team",
    desc: "High quality construction and finishes from skilled designers, construction experts and specialist craftsmen",
    img: <RiTeamFill />,
  },
  {
    id: 1,
    header: "24 / 7 Support",
    desc: "Full transparency and communication throughout the project by a dedicated project manager.!",
    img: <BiSupport />,
  },
];

export default cards;
